export class Step9 {
  constructor() {}

  getnoserviceexecutant = 'bloc_commun.simp.getnoserviceexecutant';
  getnumboncommande = 'bloc_commun.simp.getnumboncommande';
  getspan3 = 'bloc_commun.simp.getspan3';
  getregion = 'bloc_commun.simp.getregion';
  getdepartement = 'bloc_commun.simp.getdepartement';
  getetat = 'bloc_commun.simp.getetat';
  getdebiteuretranger = 'bloc_commun.simp.getdebiteuretranger';
  getdebiteurprivepersmorale = 'bloc_commun.simp.getdebiteurprivepersmorale';
  getdebiteurprivepersphysique = 'bloc_commun.simp.getdebiteurprivepersphysique';
  getgroupementcollectivites = 'bloc_commun.simp.getgroupementcollectivites';
  getcommune = 'bloc_commun.simp.getcommune';
  getautresorganismespublics = 'bloc_commun.simp.getautresorganismespublics';
  getetablissementspublicssante = 'bloc_commun.simp.getetablissementspublicssante';
  getsiret = 'bloc_commun.simp.getsiret';
  getdenomination = 'bloc_commun.simp.getdenomination';
  getadr1 = 'bloc_commun.simp.getadr1';
  getadr2 = 'bloc_commun.simp.getadr2';
  getadr3 = 'bloc_commun.simp.getadr3';
  getadr4 = 'bloc_commun.simp.getadr4';
  getcp = 'bloc_commun.simp.getcp';
  getlocalite = 'bloc_commun.simp.getlocalite';
  getpays = 'bloc_commun.simp.getpays';
  gettvaIntracommunautaire = 'bloc_commun.simp.gettvaIntracommunautaire';
  getnon = 'bloc_commun.simp.getnon';
  getoui = 'bloc_commun.simp.getoui';


}
